import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { SmppProvider } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/SMPP-Provider" component={SmppProvider} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmppProvider/routes.js